function Observable() {}

Observable.addListener = function(listenerObj) {
  if (typeof this.listeners === 'undefined') {
    this.listeners = [];
  }
  for (let i = 0; i < this.listeners.length; i++) {
    if (this.listeners[i] === listenerObj) return;
  }
  this.listeners[this.listeners.length] = listenerObj;
};

Observable.removeListener = function(listenerObj) {
  for (let i = 0; i < this.listeners.length; i++) {
    if (this.listeners[i] === listenerObj) {
      this.listeners.splice(i, 1);
      return;
    }
  }
};

Observable.notifyListeners = function(eventName, eventObj) {
  if (typeof this.listeners === 'undefined') return;
  for (let i = 0; i < this.listeners.length; i++) {
    if (typeof this.listeners[i][eventName] !== 'undefined') {
      this.listeners[i][eventName](eventObj);
    }
  }
};

export default Observable;



// WEBPACK FOOTER //
// ./src/js/mixins/observable.js